/**
 * Created by dx.yang on 2017/3/2.
 */
import 'babel-polyfill';
import Vue from 'vue';
import VueRouter from 'vue-router';
import {configure} from 'kpc/components/utils';
import {$trans} from 'ksc-i18n';
import VueClipboard from 'vue-clipboard2';
import * as commonConst from './app/store/common/constants';

Vue.prototype.$EventBus = new Vue()

// 调取网络安全组资源
import 'network-secgroup-components/src/index.sass'
import common from 'network-secgroup-components/src/js/common';

configure({useWrapper: true});
Vue.use(VueRouter);

Vue.use({
    install(Vue) {
        Vue.$trans = Vue.prototype.$trans = $trans;
    }
});
Vue.use(VueClipboard);

// require('ksc-vue-ui2/src/styles/common.sass');
require('font-awesome/css/font-awesome.css');
require('./app/styles/common.sass');
window.$ = require('jquery');
window._ = require('lodash');

// const i18n = require('ksc-i18n');
// const commonCookie = require('./app/services/common/cookie');
import commonCookie from './app/services/common/cookie';

let firstLoad = true;
window.__ksStorage__.addLangListener({
    name: 'ksc-network',
    // arg: 'KSC_LANG',
    callback: function(d) {
        if (firstLoad) {
            firstLoad = false
            return
        }
        location.reload();
    }
});

// 设置“文档”菜单地址
window.__ksStorage__.docInit({
    // 中文地址（非必填，不传该参数时打开的是文档弹层首页）
    indexUrl: '//docs.ksyun.com/products/24',
    // 英文地址（非必填，不传该参数时打开的是文档弹层首页）
    indexEnUrl: '//endocs.ksyun.com/products/24',
    // 设置文档的z-index，（非必填，不传该参数时默认是2000）
    zIndex: 10000
});


// prod环境预处理
if (KSC_SECNET_CONSOLE.ENV === 'prod') {
    (function() {
        var noop = function noop() {};
        var methods = [
            'assert', 'clear', 'count', 'debug', 'dir', 'dirxml',
            'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
            'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeLog', 'timeEnd',
            'timeStamp', 'trace', 'warn'
        ];
        var length = methods.length;
        var console = window.console || {};

        while (length--) {
            console[methods[length]] = noop;
        }
    }());
    // 关闭vue的开发配置
    Vue.config.silent = true;
    Vue.config.devtools = false;
}
if (KSC_SECNET_CONSOLE.ENV === 'test') {
    // 关闭vue的开发配置
    // Vue.config.silent = true;
    Vue.config.devtools = false;
}
let lang = commonCookie.getCookie('ksc_lang') || 'zh';
// Vue.use(i18n.VueTransPlugin, window['kvm_lang_dict']);

import {localize} from 'kpc/components/utils';

import i18nKpc from 'kpc/i18n/en-US';
import i18nPublicBusinessComponents from 'public-business-components/dicts/en';
import i18nNetworkSecgroupComponents from 'network-secgroup-components/dicts/en';
if (lang === 'en') {
    window.ksc_i18n_dict = {
        ...window['ksc_i18n_dict'],
        ...i18nPublicBusinessComponents,
        ...i18nNetworkSecgroupComponents
    };
    localize({
        ...i18nKpc
    });
}

import TableNoData from './app/components/TableNoData/index.vue';

Vue.component('TableNoData', TableNoData);

// 顶部导航region对象
window.MENU_REGION_ITEM = undefined;

const store = require('./app/store/index').default
const router = require('./app/router').default
// import routerLoading from 'ksc-vue-ui2/src/services/router-loading';
// import qoe from 'ksc-vue-ui2/src/services/qoe';
// routerLoading(router);
let popstate = false;
window.addEventListener('popstate', function(r) {
    popstate = true;
})
router.beforeEach((to, from, next) => {
    if(MENU_REGION_ITEM !== undefined){
        MENU_REGION_ITEM.remove();
    }

    if(from.matched && from.matched.length > 0 && !popstate) {
        let origin = window.location.host + '/#' + from.fullPath;
        // qoe.performance(origin);
    }
    popstate = false;

    let keywords = document.getElementsByName('keywords'),
        kw = document.createElement('meta'),
        description = document.getElementsByName('description'),
        desc = document.createElement('meta'),
        seoTitle = _.get(to, 'meta.seoContent.seoTitle', ''),
        title = _.get(to, 'meta.title');
        title = title ? ' (' + title + ')' : '';

    if (seoTitle) {
        kw.name = 'keywords';
        kw.content = _.get(to, 'meta.seoContent.seoKeyWord', '');
        desc.name = 'description';
        desc.content = _.get(to, 'meta.seoContent.seoDescription', '');
        keywords[0].parentNode.replaceChild(kw, keywords[0]);
        description[0].parentNode.replaceChild(desc, description[0]);
        document.title = seoTitle + title;
    } else {
        document.title = Vue.$trans(`云服务器`) + title;
    }
    next();
});

const VueApp = Vue.extend(common);
export default new VueApp({
    // el: '#app',
    store,
    router,
    render: h => h('router-view'),
    beforeCreate() {

        const regionListPromise = [
            store.dispatch(commonConst.regionList),
            new Promise((resolve) => {
                __ksStorage__.getValue('region', (key, value) => {
                    resolve(value)
                })
            })
        ];
        Promise.all(regionListPromise).then(([list, value]) => {
            // 有权限的region 账号region交集
            const regionCodeList = _.map(list.data, region => region.regionCode);
            const permissionList = _.intersection(regionCodeList, commonConst.regionKeyPermissionList);
            if(!permissionList.includes(value)){
                value = permissionList[0] || KSC_SECNET_CONSOLE.REGION;
            }

            store.commit(commonConst.unifiedRegion, {
                regionKey: value
            });
            this.$mount('#app');
        })
    }
})
